export default __webpack_public_path__ + "static/media/404.b858b790.svg";